import React, { useCallback, useContext, useEffect } from "react"
import i18nData from "@rogue_4/locales/zh-CN.json"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"

import i18nCommonData from "@/locales/zh-CN.json"
import { i18n } from "@/utils/i18n"
import Toast from "../../components/Toast"
import { GlobalContext, ISubPageProps } from "../../context"
import GAME_EMITTER from "./components/Emitter"
import GameMenu from "./components/Menu"
import ModalContainer from "./components/Modal"
import GameLayer from "./scene"
import { getRollInfo, getSaveData } from "./service"
import { useGameStore } from "./store"
import emitter from '../../components/Bus'
import styles from "./index.module.less"

const PageGame: React.FC<ISubPageProps> = (props) => {
    const { className, style, onExit } = props
    const {
        state: { user },
    } = useContext(GlobalContext)
    const { gameDataInit, rollDateInit } = useGameStore((state) => ({
        rollDateInit: state.rollDateInit,
        gameDataInit: state.gameDataInit,
    }))
    useEffect(() => {
        if (!user) {
            return
        }
        getSaveData()
            .then(({ code, data, msg }) => {
                if (code !== 0) {
                    Toast.message({
                        content: msg,
                    })
                } else {
                    gameDataInit(data)
                }
            })
            .catch((e) => {
                console.error(e)
                Toast.message({ content: i18nCommonData["tips.network.error"] })
            })
        getRollInfo()
            .then(({ code, data, msg }) => {
                if (code !== 0) {
                    Toast.message({
                        content: msg,
                    })
                } else {
                    rollDateInit(data)
                    console.log('data===========',data)
                    emitter.emit('updateRollData',data.contact)
                }
            })
            .catch((e) => {
                console.error(e)
                Toast.message({ content: i18nCommonData["tips.network.error"] })
            })
    }, [user])

    const handleExit = useCallback(() => {
        onExit?.()
    }, [onExit])
    return (
        <div
            className={classNames(styles.pageGame, className)}
            style={style}
            onClick={() => GAME_EMITTER.emit("NEXT")}
        >
            <GameLayer onExit={handleExit} />
            <GameMenu visible onBack={onExit} />
            <SafeAreaView
                mode="margin"
                edges={["right"]}
                className={styles.tips}
            >
                {i18n(i18nData, "rogue_4.game.tips")}
            </SafeAreaView>
            <ModalContainer />
        </div>
    )
}

export default PageGame
